<template>
  <div class="home_container">
    <div class="top-layout">
      {{ title }}
    </div>
    <div class="middle-content">
      <SalesRecords v-if="clickIndex === 1 && showSalesRecords"></SalesRecords>
      <MaintenanceRecords v-if="clickIndex === 2 && showMaintenanceRecords"></MaintenanceRecords>
      <My v-if="clickIndex === 3 && showMy" @update-value="updateParentValue"></My>
    </div>
    <div class="bottom-tab">
     <div class="item-tab" @click="clickTab(1,$t('tabmenu.name69'))" v-if="showSalesRecords">
       <div class="item-img">
        <img src="@/assets/icon-select1.png"  v-if="clickIndex === 1"/>
        <img src="@/assets/icon-unselect1.png"  v-else/>
       </div>
       <div :class="clickIndex === 1 ? 'color2' : 'color1'">{{ $t('tabmenu.name69') }}</div>
     </div>
     <div class="item-tab" @click="clickTab(2,$t('tabmenu.name68'))" v-if="showMaintenanceRecords">
      <div class="item-img">
        <img src="@/assets/icon-select2.png"  v-if="clickIndex === 2"/>
        <img src="@/assets/icon-unselect2.png"  v-else/>
      </div>
      <div :class="clickIndex === 2 ? 'color2' : 'color1'">{{ $t('tabmenu.name68') }}</div>
</div>
<div class="item-tab" @click="clickTab(3,$t('account.name12'))"  v-if="showMy">
  <div class="item-img">
    <img src="@/assets/icon-select3.png"  v-if="clickIndex === 3"/>
    <img src="@/assets/icon-unselect3.png"  v-else/>
  </div>
  <div :class="clickIndex === 3 ? 'color2' : 'color1'">{{ $t('account.name12') }}</div>
</div>
    </div>
  </div>
</template>
<script>
import SalesRecords from './salesRecords.vue'
import MaintenanceRecords from './maintenanceRecords.vue'
import My from './my.vue'
export default {
  data() {
    return {
      clickIndex: 1,
      title: this.$t('tabmenu.name69'),
      menuPerms: '',
      showSalesRecords: false,
      showMaintenanceRecords: false,
      showMy: false
    }
  },
  components: {
    SalesRecords,
    MaintenanceRecords,
    My
  },
  created() {
    this.clickIndex = Number(this.$route.query.tab) || 1
    this.title = this.$route.query.title || this.$t('tabmenu.name69')
    this.menuPerms = localStorage.getItem('menuPerms')
    if (this.menuPerms.indexOf('2182') > -1) {
      this.showSalesRecords = true
    }
    if (this.menuPerms.indexOf('2183') > -1) {
      this.showMaintenanceRecords = true
    }
    if (this.menuPerms.indexOf('2184') > -1) {
      this.showMy = true
    }
  },
  mounted() {},
  methods: {
    clickTab(index, title) {
      this.clickIndex = index
      this.title = title
    },
    updateParentValue() {
      this.title = this.$t('account.name12')
    }
  }
}
</script>
<style lang="scss" scoped>
.home_container {
  background: #fff;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .top-layout{
    height: 54px;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    background: #fff;
    // margin-top: 48px;
    color: #171717;
    font-size: 16px;
    font-weight: 500;
  }
  .middle-content{
    width: 100vw;
    background: #F6F7FB;
    display: flex;
    height: calc(100vh - 114px)
    // overflow: auto;
  }
  .bottom-tab{
    background: #fff;
    height: 60px;
    width: 100%;
    // padding: 20px 0px;
    display: flex;
    justify-content: space-between;
    .item-tab{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-size: 12px;
      cursor: pointer;
      .item-img{
        width: 22px;
        height: 22px;
        margin-bottom: 4px;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .color1{
      color: #555;
    }
    .color2{
      color: #0F73E6;
    }
  }
}
</style>
